import React, { useMemo } from 'react';

type TruncatedListProps = {
    labelName?: string;
    items: string[];
    maxChars?: number;
};
const TruncatedList = ({ items, maxChars = 60, labelName = 'Selected Items:' }: TruncatedListProps) => {
    const { displayText } = useMemo(() => {
        let charCount = labelName.length;
        const visibleItems = [];

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const nextLength = charCount + item.length + (visibleItems.length > 0 ? 2 : 0); // +2 for ", "
            if (nextLength >= maxChars) break;

            visibleItems.push(item);
            charCount = nextLength;
        }

        const remaining = items.length - visibleItems.length;
        let display = `${labelName} ${visibleItems.join(', ')}`;
        if (remaining > 0) display += `, +${remaining} more`;

        return { displayText: display };
    }, [items, maxChars]);

    return (
        <div
            className="whitespace-nowrap overflow-hidden text-ellipsis text-promoColour"
            title={`${labelName} ${items.join(', ')}`}
        >
            {displayText}
        </div>
    );
};

export default TruncatedList;
